"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentHeaderStatus = void 0;
var ShipmentHeaderStatus;
(function (ShipmentHeaderStatus) {
    ShipmentHeaderStatus["OPEN"] = "open";
    ShipmentHeaderStatus["PACKAGED"] = "packaged";
    ShipmentHeaderStatus["SHIPPED"] = "shipped";
    ShipmentHeaderStatus["INVOICED"] = "invoiced";
})(ShipmentHeaderStatus = exports.ShipmentHeaderStatus || (exports.ShipmentHeaderStatus = {}));
//# sourceMappingURL=shipment-header-status.enum.js.map